import { resolveSnowplowConfig } from './config';
import {
  canTrackSnowplowPageLeave,
  initSnowplowProvider,
  setSnowplowProviderUserId,
  trackSnowplowProviderEvent,
  trackSnowplowProviderPageView,
} from './provider';

import type { SnowplowEventParams, SnowplowInitInput } from './types';

/**
 * 初始化 Snowplow。
 * @param input - runtimeConfig 与魔方配置
 * @returns true 表示初始化成功并可发送事件
 */
export async function initSnowplow(input: SnowplowInitInput): Promise<boolean> {
  try {
    const config = resolveSnowplowConfig(input);
    return await initSnowplowProvider(config);
  } catch (error) {
    console.error('@snowplow--init', error);
    return false;
  }
}

/**
 * 旁路发送 Snowplow 事件。
 * @param eventName - 神策事件名
 * @param params - 过滤后的事件参数
 */
export function snowplowTrack(eventName: string, params: SnowplowEventParams = {}): void {
  try {
    trackSnowplowProviderEvent(eventName, params);
  } catch (error) {
    console.error('@snowplow--track', error);
  }
}

/**
 * 直接上报 Snowplow PageView，不经过神策封装。
 * @param params - PageView 事件参数
 */
export function snowplowTrackPageView(params: SnowplowEventParams = {}): void {
  try {
    trackSnowplowProviderPageView(params);
  } catch (error) {
    console.error('@snowplow--page-view', error);
  }
}

/**
 * 设置 Snowplow 业务用户 ID。
 * @param userId - 业务用户 ID；null 表示清空当前页面后续事件的用户 ID
 */
export function snowplowSetUserId(userId: string | null): void {
  try {
    setSnowplowProviderUserId(userId);
  } catch (error) {
    console.error('@snowplow--set-user-id', error);
  }
}

/**
 * 判断 Snowplow PageLeave 是否可以挂载。
 * @returns true 表示可以挂载 PageLeave
 */
export function isSnowplowPageLeaveEnabled(): boolean {
  return canTrackSnowplowPageLeave();
}
